import {ApplicationStoreType} from 'reducers';

/**
 * Try on visibility selector
 * @param {ApplicationStoreType} store - application store
 * @returns {boolean} - try on visibility
 */
export const getIsTryOnVisible = (store: ApplicationStoreType) => store.tryOnVisibility;
